module.exports = __webpack_public_path__ + "static/media/stepper-collect.e65eba9a.svg";